<template>
  <div class="autorisation-panel">
      <img class="autorisation-panel__back"
           src="../../assets/img/arrow-left.svg"
           v-if="formType != 'login'"
           v-on:click="changeFormType('login')" />

      <div class="autorisation-logo">
        <img src="../../assets/img/mft-logo__green.svg">
      </div>

      <!-- start Авторизация -->
      <form autocomplete="on"
            v-on:submit.prevent="sendAuth()"
            v-if="formType === 'login'">
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/mail.svg" class="icon-user">
          </div>
          <input name="emailC" class="form-field" placeholder="Почта" v-model="loginData.email"/>
        </label>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/menu-icon-4-line.svg" class="icon-password">
          </div>
          <input type="password" name="password" class="form-field" placeholder="Пароль" v-model="loginData.password"/>
        </label>
        <div class="autorisation_submit-line">
          <a href="javascript:void(0)" v-on:click="changeFormType('remindPass')"><i>Забыли пароль?</i></a>
          <button class="btn btn-success" type="submit">Войти</button>
        </div>
        <div class="autorisation_social-auth">
          <span>
            Вход через:
          </span>
          <div class="autorisation_social-auth_btns">
            <form method="post" :action="authLink">
              <button class="btn btn-clean" type="submit" @click="authLink = 'https://auth.mf-t.ru/accounts/google/login/'">
                <img src="../../assets/img/auth/google-icon.svg">
              </button>
              <button class="btn btn-clean" @click="authLink = 'https://auth.mf-t.ru/accounts/apple/login/'">
                <img src="../../assets/img/auth/apple-icon.svg">
              </button>
            </form>
          </div>
        </div>
        <div class="text-center">
          <p class="text-small autorisation-descr">Еще нет аккаунта в системе?</p>
          <a class="btn btn-clean btn__l" v-on:click="changeFormType('newUser')">Зарегистрироваться</a>
          <p class="text-small autorisation-descr">или</p>
          <button class="btn btn-clean btn__l" v-on:click="sendDemoAuth" disabled="disabled">Войти в демо режим</button>
        </div>
      </form>
      <!-- end Авторизация -->

      <!-- start Регистрация -->
      <form v-if="formType === 'newUser'"
            v-on:submit.prevent="sendRegistration()">
        <div class="m-title">
          Новый пользователь
        </div>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/mail.svg" class="icon-mail">
          </div>
          <input type="email" autocomplete="off" class="form-field" placeholder="Почта" v-model="registration.email"/>
        </label>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/menu-icon-4-line.svg" class="icon-password">
          </div>
          <input type="password" autocomplete="off" class="form-field" placeholder="Пароль" v-model="registration.pass1"/>
        </label>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/menu-icon-4-line.svg" class="icon-password">
          </div>
          <input type="password" autocomplete="off" class="form-field" placeholder="Повторите пароль" v-model="registration.pass2"/>
        </label>
        <div>
          <button class="btn btn-success float-right" type="submit">Создать</button>
        </div>
      </form>
      <!-- end Регистрация -->

      <!-- start Пользователь создан -->
      <form v-if="formType === 'userIsCreate'"> <!--v-on:submit.prevent="changeFormType('formTypeAddCar')"-->
        <div class="m-title">
          Новый пользователь успешно зарегистрирован
        </div>
        <p class="form-description">
          Вы можете использовать ваши данные
          для входа в личный кабинет mf-t.ru и в мобильном приложении Universe
        </p>
        <div class="autorisation_option-add-car">
          <button type="button" class="btn btn-clean btn__l" v-on:click="changeFormType('login')">Форма входа</button>
        </div>
        <p>
          <span class="text-small">Загрузить приложение Universe</span>
        </p>
        <div class="autorisation_mobile-app">
          <div class="text-small autorisation_mobile-item">
            для Android
            <a href="https://play.google.com/store/apps/details?id=megaf.auto">
              <img src="../../assets/img/android-app.png">
            </a>
          </div>
          <div class="text-small autorisation_mobile-item">
            для iOS
            <a href="/app/ios/skauto">
              <img src="../../assets/img/ios-app.png">
            </a>
          </div>
        </div>
      </form>
      <!-- end Пользователь создан -->

      <!-- start Запрос нового пароля -->
      <form v-if="formType === 'remindPass'" v-on:submit.prevent="sendRemindPass()">
        <div class="m-title">
          Вы забыли пароль?
        </div>
        <p class="form-description">
          Мы сбросим новый пароль на почту указанную при регистрации.
        </p>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/mail.svg" class="icon-mail">
          </div>
          <input type="email" autocomplete="off" name="emailC" class="form-field" placeholder="Почта" v-model="remind.email"/>
        </label>
        <div>
          <button class="btn btn-success float-right" type="submit">Отправить</button>
        </div>
      </form>
      <!-- end Запрос нового пароля -->

      <!-- start Отправка нового пароля -->
      <form v-if="formType === 'newPass'" v-on:submit.prevent="sendNewPass()">
        <div class="m-title">
          Восстановление пароля
        </div>
        <p class="form-description">
          Введите новый пароль
        </p>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/menu-icon-4-line.svg" class="icon-password">
          </div>
          <input type="password"  autocomplete="off" name="password" class="form-field" placeholder="Пароль" v-model="remind.password1"/>
        </label>
        <label class="form-control">
          <div class="form-control_icon">
            <img src="../../assets/img/form/menu-icon-4-line.svg" class="icon-password">
          </div>
          <input type="password"  autocomplete="off" name="password" class="form-field" placeholder="Повторите пароль" v-model="remind.password2"/>
        </label>
        <div>
          <button class="btn btn-success float-right" type="submit">Отправить</button>
        </div>
      </form>
      <!-- end Отправка нового пароля -->
    </div>
</template>

<script>
  import { HTTP, HTTP_AUTH } from '@/main'

  export default {
    data: function(){
      return{
        loginData: {
          email    : '',
          password : ''
        },
        registration: {
          email : '',
          pass1 : '',
          pass2 : ''
        },
        car : {
          serial : '',
          regkey : ''
        },
        remind : {
          email : '',
          password1: '',
          password2: ''
        },
        authLink : ''
      }
    },
    computed : {
      formType(){
        return this.$store.state.panels.login.type
      },
      remindData(){
        return this.$store.state.panels.login.remind
      }
    },
    methods: {
      changeFormType : function ( type ) {
        this.$store.dispatch('loginFormType', type);
        this.resetFormData(this.loginData);
        this.resetFormData(this.registration);
        this.resetFormData(this.remind);
      },
      // Авторизация
      sendAuth : function () {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if( this.loginData.email !== '' && this.loginData.password !== '' ){
          if( this.loginData.email.match( emailRegex ) !== null ){
            // Авторизуемся
            HTTP_AUTH.post('login/', {
              email : this.loginData.email,
              password: this.loginData.password
            }).then( response => {
              HTTP.defaults.headers.common['Authorization'] = 'Token ' + response.data.key;
              document.cookie = "userToken=" + response.data.key;
              document.cookie = 'activeCar=0';
              setTimeout(function () {
                window.location.reload();
              }, 100)
            }).catch( error => {
              this.resetFormData( this.loginData, ['email']);
              this.$store.dispatch('errorResponse', error );
            });
          }else{
            this.resetFormData(this.loginData, ['email']);
            this.$store.dispatch( 'addAlert', { text : 'Некорректный email', type : 'error' });
          }
        }else{
          this.$store.dispatch( 'addAlert', { text : 'Данные не заполнены', type : 'error' });
        }
      },
      // Регистрация
      sendRegistration : function () {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if( this.registration.email !== '' ){
          if( this.registration.email.match( emailRegex ) !== null ){
            if( this.registration.pass1 === this.registration.pass2 && this.registration.pass1.replace(/ /g, '') !== '' ){
              if( this.registration.pass1.length > 7 ){
                HTTP_AUTH.post('registration/token/', {
                }).then((data) => {
                  HTTP_AUTH.defaults.headers.common['X-Registration-Token'] = data.data.token;

                  HTTP_AUTH.post('registration/', {
                    email     : this.registration.email,
                    password1 : this.registration.pass1,
                    password2 : this.registration.pass2
                  }).then(() => {
                    this.resetFormData(this.registration);
                    this.$store.dispatch( 'addAlert', { text : 'На вашу почту отправлено письмо. Перейдите по ссылке в письме для подтверждения своего email.', type : 'success' });
                    this.changeFormType('login');

                    delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
                  }).catch( error => {
                    this.resetFormData(this.registration, ['email']);
                    this.$store.dispatch('errorResponse', error );

                    delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
                  });
                }).catch((error) => {
                  this.$store.dispatch('errorResponse', error );
                });
              }else{
                this.resetFormData(this.registration, ['email']);
                this.$store.dispatch( 'addAlert', { text : 'Длинна пароля должна быть не менее 8 символов', type : 'error' });
              }
            }else{
              this.resetFormData(this.registration, ['email']);
              this.$store.dispatch( 'addAlert', { text : 'Пароли не совпадают', type : 'error' });
            }
          }else{
            this.resetFormData(this.registration, ['email']);
            this.$store.dispatch( 'addAlert', { text : 'Некорректный email', type : 'error' });
          }
        }else{
          this.resetFormData(this.registration, ['email']);
          this.$store.dispatch( 'addAlert', { text : 'Введите email', type : 'error' });
        }
      },
      // Запрос для нового пароля
      sendRemindPass : function () {
        HTTP_AUTH.post('registration/token/', {
        }).then((data) => {
          HTTP_AUTH.defaults.headers.common['X-Registration-Token'] = data.data.token;
          HTTP_AUTH.post('password/reset/', {
            email     : this.remind.email,
          }).then( response => {
            this.resetFormData( this.remind);
            this.$store.dispatch( 'addAlert', { text : response.data.detail, type : 'success' });
            this.changeFormType('login');

            delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
          }).catch( error => {
            this.$store.dispatch('errorResponse', error );

            delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
          });
        }).catch((error) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      // Изменение пароля
      sendNewPass : function () {
        if( this.remind.password1 !== '' && this.remind.password2 !== '' ){
          HTTP_AUTH.post('password/reset/confirm/', {
            token : this.remindData.token,
            uid : this.remindData.uidb64,
            new_password1 : this.remind.password1,
            new_password2 : this.remind.password2
          }).then( response => {
            this.resetFormData( this.remind );
            this.$store.dispatch( 'addAlert', { text : response.data.detail, type : 'success' });
            this.changeFormType('login');
          }).catch( error => {
            this.resetFormData( this.remind, ['email', 'token', 'uidb64', 'confirm']);
            this.$store.dispatch('errorResponse', error );
          });
        }else{
          this.$store.dispatch( 'addAlert', { text : 'Поле пароля не должно быть пустым', type : 'error' });
        }
      },
      // Дэмо
      sendDemoAuth : function () {
      },
      // Сброс значений формы
      resetFormData : function (formData, skip) {
        let _formData = formData;
        skip = (skip === undefined) ? [] : skip;

        for(let key in _formData) {
          if (skip.indexOf(key) == -1) {
            this.$set( formData, key, '' );
          }
        }
      },
    }
  }
</script>